<div class="w-full search-container d-flex fl-al-center fl-justify-between grid">
  <div class="form-group form-main form-group-overrides width-100per mb-0 col-span-2">
    <div class="div-group width-100per">

      <mat-form-field appearance="fill" id="access-manager-matAutoComplete" matTooltipClass="add-member-tooltip"
        [ngClass]="{ 'disable-search': disableSearch , 'white-background':isInputFocused ,'temp-alignment': !isInputFocused }">

        <div matPrefix class="mr-2 matPrefix-search-icon"><img style="position: relative;top: 2px;"  src="assets/images/search-blue.svg" width="20px"
        height="19px" /></div>

        <input #inputField autofocus type="text" style="position: relative;top: 3px;" matInput aria-label="Number"  [formControl]="connectionUserFormControl"
          [matAutocomplete]="auto" [placeholder]="textBoxPlaceHolder" class="addMember"
          (input)="onTrustSearch($event.target.value)" (focus)="onInputFocus()" (blur)="onInputBlur()" />

          @if (connectionUserFormControl.value) {
            <div matSuffix (click)="onClearInput()">
              <mat-icon class="close-input-icon mr-4">close</mat-icon>
            </div>
          }

          <mat-autocomplete #auto="matAutocomplete" class="search-scroll-main template-Search">
            <div>
              <ng-container>
                <div class="width-100per">
                  @if ((data | addFilterReportDataList : selectedTemplate:connectionUserFormControl.value)?.length == 0) {
                    <mat-option class="h-fit" disabled>
                      <div class="flex gap-4 py-5 h-fit fl-al-center ">
                        <div class="flex" style="height: 84px; width: 84px;">
                          <img src="assets/images/no-matchin-result.svg" />
                        </div>
                        <div style="color: #18191C;">
                          <div class="font-semibold" style="font-size: 22px; margin-bottom: 8px; line-height: 24px;">No
                          matching results to show</div>
                          <div class="text-sm font-normal">Try changing the search terms, or add a new template</div>
                        </div>
                      </div>
                    </mat-option>
                  }

                  @if ( (data | addFilterReportDataList : selectedTemplate:connectionUserFormControl.value)?.length != 0) {
                    <div>
                      <div class="search-list-overflow ">
                        <div style="overflow: auto;max-height: 270px;padding:0px 15px;">
                          @for (entity of data | addFilterReportDataList : selectedTemplate:connectionUserFormControl.value; track entity; let i = $index) {
                            <mat-option class="search-list-box"
                              (onSelectionChange)="selectConnectedUser(entity)">
                              <div class="d-flex fl-justify-between fl-al-center">
                                <div class="d-flex fl-al-center gap-3">
                                  <div>
                                    @if (!entity?.profile_image_url) {
                                      <img class="back-avatar-grup" src="assets/images/avtar-trust.svg"
                                        />
                                    }
                                    @if (entity?.profile_image_url) {
                                      <ngx-avatars size="32" [src]="entity?.profile_image_url"
                                        [name]="entity?.form_name"
                                        [round]="false"
                                        cornerRadius="8"
                                      initialsSize="2"></ngx-avatars>
                                    }
                                  </div>
                                  <div>
                                    <div class="text-sm font-normal font-sans color-[#18191C]">{{
                                      entity?.form_name
                                    }}</div>
                                    <div class="text-[10px] leading-3 font-normal font-sans color-[#707070]">{{
                                    entity?.type }}</div>
                                  </div>
                                </div>
                                <div class="flex " style="margin-top: 6px;" >
                                  @if (entity?.vaultUserForm?.id) {
                                    <p class="text-center px-1 w-16 font-bold text-[10px] text-[#DEA000] rounded bg-[#FFF2CD] m-0 "  >
                                      In Use
                                    </p>
                                  }
                                  @if (!entity?.vaultUserForm?.id) {
                                    <p class="text-center px-1 w-16 font-bold text-[10px] text-[#1AA140] rounded bg-[#DAF4F2] m-0">
                                      Available
                                    </p>
                                  }
                                </div>
                              </div>
                            </mat-option>
                          }
                        </div>
                      </div>
                    </div>
                  }

                  <div class="footer-container p-4">

                    <mat-option class="footer-menu" (click)="connectToMX()"
                      >
                      <div class="flex-center">
                        <img src="assets/images/mx-logo.svg" />

                      </div>
                    </mat-option>
                  </div>
                </div>

                <!-- *ngIf="loader$ | async" -->
                @if (loader) {
                  <mat-option class="h-fit">
                    <div class="search-box-container">
                      <div class="loader-container grid grid-cols-7 p-4 pb-0">
                      </div>
                    </div>
                  </mat-option>
                }

              </ng-container>
            </div>

          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </div>